import React from 'react';
import Company from '@/finsight/ui/components/static/Company';
import withFinsightGlobalProps from '@/finsight/application/withFinsightGlobalProps';

export const getServerSideProps = withFinsightGlobalProps(() => ({
  props: {},
}));

const ContactUs = () => <Company />;

export default ContactUs;
